import { defineField, defineType } from 'sanity'
import { strongEmLink } from '../../data/richText'

export default defineType({
  title: 'Fitment Block',
  name: 'fitmentBlock',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Super Title',
      name: 'superTitle',
      description: 'Optional. Will be displayed above the title.',
      type: 'string',
    }),
    defineField({
      title: 'Content',
      name: 'content',
      type: 'array',
      of: strongEmLink,
    }),
    defineField({
      title: 'Button List',
      name: 'buttonList',
      type: 'buttonList',
    }),
    defineField({
      title: 'Image',
      name: 'image',
      type: 'image',
      options: {
        hotspot: true,
      },
    }),
    defineField({
      title: 'Background Image',
      name: 'backgroundImage',
      type: 'image',
      description:
        'Optional. If the background image is not provided, this block will use the solid white background.',
      options: {
        hotspot: true,
      },
    }),
    defineField({
      title: 'Text Color',
      name: 'textColor',
      type: 'string',
      description:
        'Select color which will stand out from the background image.',
      options: {
        list: [
          { title: 'Black', value: 'black' },
          { title: 'White', value: 'white' },
        ],
        layout: 'radio',
      },
      initialValue: 'black',
      hidden: ({ parent }) => !parent?.backgroundImage,
    }),
    defineField({
      title: 'Checklist',
      name: 'checklist',
      type: 'array',
      of: [
        {
          type: 'string',
        },
      ],
    }),
    defineField({
      title: 'Button',
      type: 'link',
      name: 'button',
    }),
  ],
  preview: {
    select: {
      title: 'title',
      media: 'image',
    },
    prepare({ title, media }) {
      return {
        title,
        media,
        subtitle: 'Fitment Block',
      }
    },
  },
})
